const React = require('react');
const config = require('../../config');
const classnames = require('classnames');
import { TakeoutMethod } from '../../helper/const';
const IScroll = require('@portal/iscroll/build/iscroll-probe');
const shallowCompare = require('react-addons-shallow-compare');

const shopLogoDefault = require('../../asset/images/logo_default.svg');
const noDataImageUrl = require('../../asset/images/shoplist-no-data.svg');
const failedImageUrl = require('../../asset/images/load-shop-list-failed.png');
const noDataImageUrlSpe = require('../../asset/images/shoplist-no-data-spe.svg');
const StandardAddrselectSearchbox = require('../mui/standard-addrselect/standard-addrselect-searchbox');
const StandardAddrselectSearchboxYCS = require('../mui/standard-addrselect/standard-addrselect-searchbox-ycs');
import HttpsProtocolImage from '../common/https-protocol-image';
// eslint-disable-next-line
import { getPoint } from '../../helper/map-TARGET_AREA';

import FormattedMessage from '@/intl/formatted-message';
import { formatMessage } from '../../intl/helper';
import shopText from '../../intl/messages/shop';
import muiText from '../../intl/messages/mui';
import activateText from '../../intl/messages/activate';

require('./shop-all.scss');

const shopAll = React.createClass({
  displayName: 'shopAll',
  propTypes: {
    // reducers
    allNearShopList: React.PropTypes.object,
    allNearShopListWs: React.PropTypes.object,
    allNearShopListZt: React.PropTypes.object,
    allShopListWs: React.PropTypes.array,
    allShopListZt: React.PropTypes.array,
    chosenPositionSendToPage: React.PropTypes.object,
    curPosition: React.PropTypes.object,
    tabActive: React.PropTypes.string,
    showTab: React.PropTypes.bool,
    cityListWs: React.PropTypes.array,
    cityListZt: React.PropTypes.array,
    yunChengSchoolFlag: React.PropTypes.bool,
    // actions
    getAllShopList: React.PropTypes.func.isRequired,
    getYCSAllShopList: React.PropTypes.func.isRequired,
    getNearShopList: React.PropTypes.func.isRequired,
    setLoadMsg: React.PropTypes.func.isRequired,
    clearNearShopListWs: React.PropTypes.func.isRequired,
    clearNearShopListZt: React.PropTypes.func.isRequired,
    clearAllShopListWs: React.PropTypes.func.isRequired,
    clearAllShopListZt: React.PropTypes.func.isRequired,
    getShowContentStatus: React.PropTypes.func.isRequired,
    // props
    addressOk: React.PropTypes.any.isRequired,
    loading: React.PropTypes.bool,
    setErrorMsg: React.PropTypes.func,
  },

  getInitialState() {
    const { showAllFromShopAllWS, showAllFromShopAllZT, chosenPositionWS, chosenPositionZT } = this.props;

    return {
      showAllShop: false,
      showLoad: false,
      showCityChangeList: false,
      cityWS: formatMessage(muiText.muinearbyStore),
      cityZT: formatMessage(muiText.muinearbyStore),
      selectTypeWS: showAllFromShopAllWS ? 'all' : 'near',
      selectTypeZT: showAllFromShopAllZT ? 'all' : 'near',
      chosenPositionWS: chosenPositionWS || null,
      chosenPositionZT: chosenPositionZT || null,
      keyWordWS: '',
      keyWordZT: '',
      dinningNameWS: '一食堂',
      dinningNameTS: '一食堂',
      forceCityPopupVisible: false,
    };
  },

  componentDidMount() {
    this.pageNumNearWS = 1; // 外送附近门店pageNum
    this.pageNumNearZT = 1; // 自提附近门店pageNum
    this.pageNumAllWS = 1; // 外送所有门店pageNum
    this.pageNumAllZT = 1; // 自提所有门店pageNum

    this.isRefresh = true; // 是否刷新
    const iScroll = (this.iScroll = new IScroll('.shop-all', {
      click: true,
      tap: true,
      probeType: 3,
    }));

    iScroll.on('scrollStart', () => {
      this._className = '';
    });

    iScroll.on('scroll', () => {
      const distance = Math.abs(iScroll.y) - Math.abs(iScroll.maxScrollY);
      if (distance >= 80) {
        this._className = 'flip';
      }
    });

    iScroll.on('scrollEnd', () => {
      if (this._className === 'flip') {
        this.props.setLoadMsg({ status: true, word: '加载中...' });
        this.addItems();
      }
    });
  },

  componentWillReceiveProps(nextProps) {
    if (this.props.tabActive !== nextProps.tabActive) {
      this.setState({ showAllShop: false, showLoad: false });
    }
  },

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  },

  componentDidUpdate(prevProps, prevState) {
    this.iScroll.refresh();
  },

  getAllShopList() {
    const { allShopListWs, allShopListZt, tabActive } = this.props;
    let allShopList = [];
    let wholeShopList = [];

    if (tabActive === 'ws') {
      allShopList = allShopListWs;
      const inShopList = allShopList && allShopList.length ? allShopList[0].inShopList : [];
      const outShopList = allShopList && allShopList.length ? allShopList[0].outShopList : [];
      if (inShopList && inShopList.length) {
        wholeShopList.push(
          <div key="inShopList">
            <div className="inout-shop-title o-bg-grey">
              <FormattedMessage {...shopText.shopdistributionAble} />
            </div>
            {this.getAllShopListOptions(allShopList, 'inShop')}
          </div>,
        );
      }
      if (outShopList && outShopList.length) {
        wholeShopList.push(
          <div key="outShopList">
            <div className="inout-shop-title o-bg-grey">
              <FormattedMessage {...shopText.shopcannotDistributeShop} />
            </div>
            {this.getAllShopListOptions(allShopList, 'outShop')}
          </div>,
        );
      }
    } else if (tabActive === 'zt') {
      allShopList = allShopListZt;
      wholeShopList = this.getAllShopListOptions(allShopList);
    }

    if (wholeShopList.length > 0) {
      return wholeShopList;
    }

    return false;
  },

  setShopListContent() {
    const { allNearShopListWs, allNearShopListZt, tabActive, yunChengSchoolFlag } = this.props;
    const shopListContentItem = {
      nearShopList: [],
      noDataWord: '',
      noPosWord: '',
      imgNoDataUrl: '',
    };

    if (tabActive === 'ws') {
      shopListContentItem.nearShopList = allNearShopListWs.cList; // 外送
      shopListContentItem.inShopList = allNearShopListWs.inShopList; // 外送 -- 可配送范围内
      shopListContentItem.outShopList = allNearShopListWs.outShopList; // 外送 -- 不可配送范围内
      shopListContentItem.imgNoDataUrl = allNearShopListWs.error ? failedImageUrl : noDataImageUrlSpe;
      shopListContentItem.noDataWord = allNearShopListWs.error
        ? formatMessage(shopText.loadNearShopListFailed)
        : formatMessage(shopText.shopcannotDistributeAddress);
      shopListContentItem.noPosWord = formatMessage(shopText.shoplocateFailed2);
    } else if (tabActive === 'zt') {
      shopListContentItem.nearShopList = allNearShopListZt.cList; // 自提
      shopListContentItem.imgNoDataUrl = allNearShopListZt.error ? failedImageUrl : noDataImageUrl;
      shopListContentItem.noDataWord = allNearShopListZt.error
        ? formatMessage(shopText.loadNearShopListFailed)
        : yunChengSchoolFlag
        ? formatMessage(shopText.shopnoStoreNearby)
        : formatMessage(shopText.shopnoShopNearby);
      shopListContentItem.noPosWord = formatMessage(shopText.shoplocateFailedMSG);
    }

    return shopListContentItem;
  },

  // YCS 品牌
  getYCSNearShopList() {
    const { nearShopList, noDataWord, imgNoDataUrl } = this.setShopListContent();
    let content = '';

    if (nearShopList && nearShopList.length > 0) {
      content = this.getNearShopListOptions(nearShopList);
    } else if (nearShopList && nearShopList.length === 0) {
      content = (
        <div className="of">
          <img src={imgNoDataUrl} alt="没有数据" className="noDataImage" />
          <span className="locate-fail">{noDataWord}</span>
        </div>
      );
    }
    return <div>{content}</div>;
  },

  // YCS 品牌
  getYCSAllShopList() {
    const { allShopListWs, allShopListZt, tabActive } = this.props;

    let allShopList = [];

    if (tabActive === 'ws') {
      allShopList = allShopListWs;
    } else if (tabActive === 'zt') {
      allShopList = allShopListZt;
    }

    const wholeShopList = this.getAllShopListOptions(allShopList);

    if (wholeShopList.length > 0) {
      return wholeShopList;
    }
    return false;
  },

  // 门店列表
  getAllShopListOptions(allShopList, type) {
    return (allShopList || []).map((item, index) => {
      let list = item.cList;
      if (type === 'inShop') list = item.inShopList;
      if (type === 'outShop') list = item.outShopList;

      return (
        <div className="shop-list-outer" key={`shoplist${index}`} onTouchStart={this.handleUserInputBlur}>
          <ul className="o-list o-border--top o-border--bottom">
            {list && list.length > 0
              ? list.map((itemt, indext) => {
                  const toAddress = this.handleItemStatus(itemt);

                  if (toAddress) {
                    return null;
                  }

                  const imgUrl = itemt.commercialLogo || shopLogoDefault;
                  let openStatus = itemt.openStatus ? formatMessage(shopText.openFlag) : formatMessage(shopText.closedFlag);
                  openStatus = itemt.isOpenStore ? openStatus : formatMessage(shopText.shopturnOff);

                  const isAcceptPreOrder = !itemt.openStatus && itemt.isAcceptTakeaway; // 是否接受预定
                  openStatus = isAcceptPreOrder ? formatMessage(shopText.acceptPreOrderIng, { ing: '' }) : openStatus;

                  return (
                    <li className="o-list__item c-shop-entry" key={itemt.commercialID} onTouchTap={() => this.jumpToShopIndex(itemt.commercialID)}>
                      <div className="o-media">
                        <HttpsProtocolImage src={imgUrl} className="o-media__img c-shop-entry__img" alt="默认图片" loadErrorImageSrc={shopLogoDefault} />
                        <div className="o-media__body c-description">
                          <div className="c-description__title">
                            <div className="o-text-ellipsis">{itemt.commercialName || formatMessage(shopText.shopanonymousShop)}</div>
                          </div>
                          <div className="c-description__body c-shop-entry__meta">
                            <p className="c-shop-entry__name">
                              <span
                                className={classnames('c-shop-entry__status o-fz--11', {
                                  'c-shop-entry__status--off': !itemt.openStatus || !itemt.isOpenStore,
                                  'c-shop-entry__status--on': (itemt.openStatus && itemt.isOpenStore) || isAcceptPreOrder,
                                })}
                              >
                                {openStatus}
                              </span>
                              <span className="o-fz--13">{itemt.busiName}</span>
                            </p>
                            {this.props.yunChengSchoolFlag ? '' : <span>{this.formatDistance(itemt.distance)}</span>}
                          </div>
                        </div>
                      </div>
                    </li>
                  );
                })
              : false}
          </ul>
        </div>
      );
    });
  },

  handleItemStatus(item) {
    const { tabActive } = this.props;
    const { toShop, toHome } = item || {};

    if ((tabActive === 'ws' && toHome === TakeoutMethod.CLOSE) || (tabActive === 'zt' && toShop === TakeoutMethod.CLOSE)) {
      return true;
    }

    return false;
  },

  // 附近门店列表
  getNearShopListOptions(nearShopList, hideCityLink) {
    return (
      <div className="shop-list-outer" onTouchStart={this.handleUserInputBlur}>
        <ul className="o-list o-border--top o-border--bottom">
          {nearShopList.map((item, index) => {
            const toAddress = this.handleItemStatus(item);

            if (toAddress) {
              return null;
            }

            // openStatus 营业中/已打烊   isOpenStore 移动门店是否开启
            const imgUrl = item.commercialLogo || shopLogoDefault;
            let openStatus = item.openStatus === true ? formatMessage(shopText.openFlag) : formatMessage(shopText.closedFlag);
            openStatus = item.isOpenStore ? openStatus : formatMessage(shopText.shopturnOff);
            const isAcceptPreOrder = !item.openStatus && item.isAcceptTakeaway; // 是否接受预定
            openStatus = isAcceptPreOrder ? formatMessage(shopText.acceptPreOrderIng, { ing: '' }) : openStatus;

            return (
              <li className="o-list__item c-shop-entry" key={item.commercialID} onTouchTap={() => this.jumpToShopIndex(item.commercialID)}>
                <div className="o-media">
                  <HttpsProtocolImage src={imgUrl} className="o-media__img c-shop-entry__img" alt="默认图片" loadErrorImageSrc={shopLogoDefault} />
                  <div className="o-media__body c-description">
                    <div className="c-description__title">
                      <div className="o-text-ellipsis">{item.commercialName || formatMessage(shopText.shopanonymousShop)}</div>
                    </div>
                    <div className="c-description__body c-shop-entry__meta">
                      <p className="c-shop-entry__name">
                        <span
                          className={classnames('c-shop-entry__status o-fz--11', {
                            'c-shop-entry__status--off': !item.openStatus || !item.isOpenStore,
                            'c-shop-entry__status--on': (item.openStatus && item.isOpenStore) || isAcceptPreOrder,
                          })}
                        >
                          {openStatus}
                        </span>
                        <span className="o-fz--13">{item.busiName}</span>
                      </p>
                      {this.props.yunChengSchoolFlag ? '' : <span>{this.formatDistance(item.distance)}</span>}
                    </div>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
        {hideCityLink ? '' : this.renderViewShopInCityLink()}
      </div>
    );
  },
  getNearShopList() {
    const { addressOk, loading } = this.props;
    const { /* inShopList, outShopList, */ nearShopList, noDataWord, noPosWord, imgNoDataUrl } = this.setShopListContent();
    let content = '';

    if (!addressOk) {
      content = (
        <div className="of">
          <img src={noDataImageUrl} alt="定位失败" className="noDataImage" />
          <span className="locate-fail">{noPosWord}</span>
          {this.renderViewShopInCityLink()}
        </div>
      );
    } else if (nearShopList && nearShopList.length > 0) {
      content = this.getNearShopListOptions(nearShopList);
    } else if (loading) {
      content = null;
    } else {
      content = (
        <div className="of">
          <img src={imgNoDataUrl} alt="没有数据" className="noDataImage" />
          <span className="locate-fail">{noDataWord}</span>
          {this.renderViewShopInCityLink()}
        </div>
      );
    }

    return content ? <div>{content}</div> : null;
  },
  setLocalStorage() {
    const { tabActive, chosenPositionSendToPage, showTab } = this.props;
    localStorage.basicListInfo = JSON.stringify({
      way: tabActive,
      city: chosenPositionSendToPage.city,
      point: { longitude: chosenPositionSendToPage.longitude, latitude: chosenPositionSendToPage.latitude },
      showTab,
    });
  },
  getShowContentStatus() {
    const { selectTypeWS, selectTypeZT } = this.state;
    const { tabActive } = this.props;
    let showNear = true;

    switch (tabActive) {
      case 'ws': {
        showNear = selectTypeWS === 'near';
        break;
      }
      case 'zt': {
        showNear = selectTypeZT === 'near';
        break;
      }
      default:
        break;
    }

    return { showNear, showAll: !showNear };
  },
  scrollToTop() {
    this.iScroll.scrollTo(0, 0); // 回到顶部
  },
  // YCS
  dinningChange(dinningObj) {
    this.setState({ dinningRoomIndex: parseInt(dinningObj.value, 10), ycsSelectType: true });
    const { getYCSAllShopList, tabActive } = this.props;

    if (tabActive === 'ws') {
      this.setState({ dinningNameWS: `${dinningObj.dinningName}`, selectTypeWS: 'all' }, () => {
        const pageNum = 1;
        const keyWord = '';
        const dinningRoomIndex = this.state.dinningRoomIndex;
        const listObjParam = { pageNum, keyWord, dinningRoomIndex, tabActive };

        this.props.clearNearShopListWs();
        this.props.clearAllShopListWs();

        getYCSAllShopList(listObjParam);
      });
    } else if (tabActive === 'zt') {
      this.setState({ dinningNameTS: `${dinningObj.dinningName}`, selectTypeZT: 'all' }, () => {
        const pageNum = 1;
        const keyWord = '';
        const dinningRoomIndex = this.state.dinningRoomIndex;
        const listObjParam = { pageNum, keyWord, dinningRoomIndex, tabActive };

        this.props.clearNearShopListZt();
        this.props.clearAllShopListZt();

        getYCSAllShopList(listObjParam);
      });
    }

    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
  handleSuggestVisible() {},
  handleCityPopupVisible(visible) {
    this.setState({ forceCityPopupVisible: visible });
  },
  handleViewShopsInTheCity() {
    const { addressOk, curPosition, tabActive, chosenPositionSendToPage, allNearShopListWs, allNearShopListZt } = this.props;
    const isLoadError = (tabActive === 'ws' && allNearShopListWs.error) || (tabActive === 'zt' && allNearShopListZt.error);

    // 定位失败，加载附近店铺列表失败 弹出城市选择浮层
    if (!addressOk || isLoadError) {
      this.setState({ forceCityPopupVisible: true });
      return;
    }

    const cityList = this.props[tabActive === 'ws' ? 'cityListWs' : 'cityListZt'];
    if (!cityList) {
      return;
    }

    const shopList = this.setShopListContent().nearShopList || [];
    const [first = {}] = shopList;
    const cityNameFromSendToPage = chosenPositionSendToPage.city;
    const cityName = curPosition.city || first.cityName;
    const cityFromSendToPage = cityList.filter(item => cityNameFromSendToPage && cityNameFromSendToPage.indexOf(item.name) === 0)[0];
    const city = cityList.filter(item => cityName && cityName.indexOf(item.name) === 0)[0];
    if (!cityFromSendToPage) {
      // 如果没有匹配到所选的地区 那么就是用当前区域
      if (!city) {
        this.setState({ forceCityPopupVisible: true });
        return;
      }
      this.cityChange({ name: city.name, value: city.id });
      return;
    }
    this.cityChange({ name: cityFromSendToPage.name, value: cityFromSendToPage.id });
  },
  cityChange(cityObj) {
    const {
      tabActive,
      getAllShopList,
      getNearShopList,
      curPosition,
      clearNearShopListWs,
      clearNearShopListZt,
      clearAllShopListWs,
      clearAllShopListZt,
      setLoadMsg,
      getShowContentStatus,
      chosenPositionSendToPage,
      setErrorMsg,
    } = this.props;
    setLoadMsg({ status: true, word: formatMessage(shopText.shopChanging) });

    const { selectType } = this.state;
    const { name: cityName } = cityObj;

    if (cityObj.value === 'near' && selectType !== 'near') {
      if (tabActive === 'ws') {
        this.setState({ cityWS: cityName, selectTypeWS: 'near' });
        getShowContentStatus({ showNearFromShopAllWS: true, showAllFromShopAllWS: false, lastCityNameWS: cityName });
      } else {
        this.setState({ cityZT: cityName, selectTypeZT: 'near' });
        getShowContentStatus({ showNearFromShopAllZT: true, showAllFromShopAllZT: false, lastCityNameZT: cityName });
      }
    } else if (selectType !== 'all') {
      if (tabActive === 'ws') {
        this.setState({ cityWS: cityName, selectTypeWS: 'all' });
        getShowContentStatus({ showNearFromShopAllWS: false, showAllFromShopAllWS: true, lastCityNameWS: cityName });
      } else {
        this.setState({ cityZT: cityName, selectTypeZT: 'all' });
        getShowContentStatus({ showNearFromShopAllZT: false, showAllFromShopAllZT: true, lastCityNameZT: cityName });
      }
    }

    if (this.timer) {
      clearTimeout(this.timer);
    }
    // 根据城市获取坐标
    if (cityObj.value === 'near') {
      if (tabActive === 'ws') {
        this.pageNumNearWS = 1;
        clearNearShopListWs();
      } else {
        this.pageNumNearZT = 1;
        clearNearShopListZt();
      }
      this.timer = setTimeout(() => {
        getNearShopList(chosenPositionSendToPage, tabActive, 1, '', () => {
          setTimeout(() => {
            this.scrollToTop();
          }, 0);
        });
      }, 500);
      return;
    }

    setLoadMsg({ status: true, word: '城市选择中...' });

    if (tabActive === 'ws') {
      clearAllShopListWs();
    } else if (tabActive === 'zt') {
      clearAllShopListZt();
    }

    // 重庆城区 地图定位不出经纬度，改成重庆市-产品杨森提的解决方案
    if(cityObj && cityObj.name === '重庆城区'){
      cityObj.name = '重庆';
    }
    getPoint(cityObj.name, cityObj.name)
      .then(point => {
        if (tabActive === 'ws') {
          // 外送操作
          const chosenPositionWS = { city: `${cityObj.name}`, cityId: cityObj.value, longitude: '', latitude: '', isGetLoc: true };
          Object.assign(chosenPositionWS, { longitude: point.lng, latitude: point.lat });
          getShowContentStatus({ chosenPositionWS });
          this.setState(
            {
              chosenPositionWS,
              keyWordWS: '',
            },
            () => {
              this.timer = setTimeout(() => {
                getAllShopList(chosenPositionWS, curPosition, chosenPositionSendToPage, tabActive, 1, '', () => {
                  setTimeout(() => {
                    this.scrollToTop();
                    // this.iScroll.scrollTo(0, 0); // 回到顶部
                  }, 0);
                });
                this.pageNumAllWS = 1;
              }, 500);
            },
          );
        } else if (tabActive === 'zt') {
          // 自提操作
          const chosenPositionZT = { city: `${cityObj.name}`, cityId: cityObj.value, longitude: '', latitude: '', isGetLoc: true };
          Object.assign(chosenPositionZT, { longitude: point.lng, latitude: point.lat });
          getShowContentStatus({ chosenPositionZT });
          this.setState(
            {
              chosenPositionZT,
              keyWordZT: '',
            },
            () => {
              this.timer = setTimeout(() => {
                getAllShopList(chosenPositionZT, curPosition, chosenPositionSendToPage, tabActive, 1, '', () => {
                  setTimeout(() => {
                    this.scrollToTop();
                  }, 0);
                });
                this.pageNumAllZT = 1;
              }, 500);
            },
          );
        }
      })
      .catch(() => {
        setErrorMsg(formatMessage(activateText.activateCardPlsRetry));
        setLoadMsg({ status: false, word: '' });
      });
  },
  handleUserInput(keyWord, type) {
    const { selectTypeWS, selectTypeZT, chosenPositionWS, chosenPositionZT, dinningRoomIndex } = this.state;
    const {
      curPosition,
      getNearShopList,
      getAllShopList,
      clearNearShopListWs,
      clearNearShopListZt,
      clearAllShopListWs,
      clearAllShopListZt,
      getYCSAllShopList,
      yunChengSchoolFlag,
      chosenPositionSendToPage,
    } = this.props;

    if (this.timer) {
      clearTimeout(this.timer);
    }

    this.setState({ keyWord }, () => {
      const formatKeyWord = keyWord
        .replace(/\?/g, '%3F')
        .replace(/&/g, '%26')
        .replace(/=/g, '%3D')
        .replace(/#/g, '%23');
      this.timer = setTimeout(() => {
        if (type === 'ws') {
          if (selectTypeWS === 'near') {
            getNearShopList(curPosition, type, 1, formatKeyWord);
            this.pageNumNearWS = 1;
            clearNearShopListWs();
          } else {
            if (yunChengSchoolFlag === true) {
              getYCSAllShopList({ tabActive: type, pageNum: 1, keyWord: formatKeyWord, dinningRoomIndex: `${dinningRoomIndex}` });
            } else {
              getAllShopList(chosenPositionWS, curPosition, chosenPositionSendToPage, type, 1, formatKeyWord);
            }
            this.pageNumAllWS = 1;
            clearAllShopListWs();
          }
        } else if (type === 'zt') {
          if (selectTypeZT === 'near') {
            getNearShopList(curPosition, type, 1, formatKeyWord);
            this.pageNumNearZT = 1;
            clearNearShopListZt();
          } else {
            if (yunChengSchoolFlag) {
              getYCSAllShopList({ tabActive: type, pageNum: 1, keyWord: formatKeyWord, dinningRoomIndex: `${dinningRoomIndex}` });
            } else {
              getAllShopList(chosenPositionZT, curPosition, chosenPositionSendToPage, type, 1, formatKeyWord);
            }
            this.pageNumAllZT = 1;
            clearAllShopListZt();
          }
        }
      }, 500);
    });
  },
  jumpToShopIndex(commercialID) {
    // 进入门店
    this.setLocalStorage();

    location.href = `${config.dishMenu4takeoutURL}?shopId=${commercialID}&type=WM&uniqueId=WM`;
  },
  addItems() {
    // 滑动加载
    const { selectTypeWS, selectTypeZT, chosenPositionWS, chosenPositionZT, dinningRoomIndex } = this.state;
    const { getAllShopList, getNearShopList, curPosition, tabActive, yunChengSchoolFlag, getYCSAllShopList, chosenPositionSendToPage } = this.props;

    if (tabActive === 'ws') {
      if (selectTypeWS === 'near') {
        this.pageNumNearWS++; // 外送附近门店pageNum
        getNearShopList(curPosition, tabActive, this.pageNumNearWS, '');
      } else {
        this.pageNumAllWS++; // 外送所有门店pageNum
        if (yunChengSchoolFlag) {
          getYCSAllShopList({ tabActive, pageNum: this.pageNumAllWS, keyWord: '', dinningRoomIndex });
        } else {
          getAllShopList(chosenPositionWS, curPosition, chosenPositionSendToPage, tabActive, this.pageNumAllWS, '');
        }
      }
    } else if (tabActive === 'zt') {
      if (selectTypeZT === 'near') {
        this.pageNumNearZT++; // 自提附近门店pageNum
        getNearShopList(curPosition, tabActive, this.pageNumNearZT, '');
      } else {
        this.pageNumAllZT++; // 自提所有门店pageNum
        if (yunChengSchoolFlag) {
          getYCSAllShopList({ tabActive, pageNum: this.pageNumAllZT, keyWord: '', dinningRoomIndex });
        } else {
          getAllShopList(chosenPositionZT, curPosition, chosenPositionSendToPage, tabActive, this.pageNumAllZT, '');
        }
      }
    }
  },
  errorPic(e) {
    const evt = e;
    evt.target.src = shopLogoDefault;
  },
  formatDistance(distance) {
    if (!distance) {
      return;
    }
    let apart = parseInt(distance, 10);
    if (apart === 10000000) {
      apart = '';
    } else if (apart >= 1000) {
      apart = `≤${parseFloat((apart / 1000).toFixed(1))}km`;
    } else {
      apart = `≤${apart}m`;
    }
    return apart;
  },
  handleUserInputBlur() {
    const inputDoms = [].slice.call(document.querySelectorAll('input'));
    inputDoms.forEach((item, index) => {
      item.blur();
    });
  },
  renderShopListWs() {
    const { cityListWs, lastCityNameWS } = this.props;
    const { showCityChangeList, cityWS, forceCityPopupVisible } = this.state;
    const currentCityWs = { name: lastCityNameWS || cityWS || '北京市' };

    return (
      <StandardAddrselectSearchbox
        forceCityPopupVisible={forceCityPopupVisible}
        onCurrentCityChange={this.cityChange}
        currentCity={currentCityWs}
        onUserInput={keyWord => {
          this.handleUserInput(keyWord, 'ws');
        }}
        showCityChangeList={showCityChangeList}
        placeholder={formatMessage(shopText.shopinputTakeOutShop)}
        // 此处需要屏蔽
        onSetSuggestVisible={this.handleSuggestVisible}
        onSetCityPopupVisible={this.handleCityPopupVisible}
        cityList={cityListWs || []}
        hasNearChosen
        hasInputIcon={false}
      />
    );
  },
  renderShopListZt() {
    const { cityListZt, lastCityNameZT } = this.props;
    const { showCityChangeList, cityZT, forceCityPopupVisible } = this.state;
    const currentCityZt = { name: lastCityNameZT || cityZT || '北京市' };
    return (
      <StandardAddrselectSearchbox
        forceCityPopupVisible={forceCityPopupVisible}
        onCurrentCityChange={this.cityChange}
        currentCity={currentCityZt}
        onUserInput={keyWord => {
          this.handleUserInput(keyWord, 'zt');
        }}
        showCityChangeList={showCityChangeList}
        placeholder={formatMessage(shopText.shopinputSelfPick)}
        // 此处需要屏蔽
        onSetSuggestVisible={this.handleSuggestVisible}
        onSetCityPopupVisible={this.handleCityPopupVisible}
        cityList={cityListZt || []}
        hasNearChosen
        hasInputIcon={false}
      />
    );
  },
  renderYcsShopListWs() {
    const { dinningNameWS, showCityChangeList, cityListWs } = this.state;
    const { yunChengSchoolFlag } = this.props;
    const currentCityWs = { name: dinningNameWS ? this.state.dinningNameWS : '一食堂' };
    return (
      <StandardAddrselectSearchboxYCS
        onCurrentCityChange={this.cityChange}
        currentCity={currentCityWs}
        onUserInput={keyWord => {
          this.handleUserInput(keyWord, 'ws');
        }}
        showCityChangeList={showCityChangeList}
        placeholder={formatMessage(shopText.shopinputStoreToSearch)}
        // 此处需要屏蔽
        onSetSuggestVisible={this.handleSuggestVisible}
        cityList={cityListWs || []}
        hasNearChosen
        yunChengSchoolFlag={yunChengSchoolFlag}
        dinningChange={this.dinningChange}
        hasInputIcon={false}
        searchBlackBg={yunChengSchoolFlag}
      />
    );
  },
  renderYcsShopListZt() {
    const { dinningNameTS, showCityChangeList } = this.state;
    const { cityListZt, yunChengSchoolFlag } = this.props;
    const currentCityZt = { name: dinningNameTS ? this.state.dinningNameTS : '一食堂' };

    return (
      <StandardAddrselectSearchboxYCS
        onCurrentCityChange={this.cityChange}
        currentCity={currentCityZt}
        onUserInput={keyWord => {
          this.handleUserInput(keyWord, 'zt');
        }}
        showCityChangeList={showCityChangeList}
        placeholder={formatMessage(shopText.shopinputStoreToSearch)}
        // 此处需要屏蔽
        onSetSuggestVisible={this.handleSuggestVisible}
        cityList={cityListZt || []}
        hasNearChosen
        yunChengSchoolFlag={yunChengSchoolFlag}
        dinningChange={this.dinningChange}
        hasInputIcon={false}
      />
    );
  },
  renderViewShopInCityLink() {
    const { tabActive, yunChengSchoolFlag } = this.props;

    if (yunChengSchoolFlag) {
      return null;
    }

    if (tabActive === 'ws' || tabActive === 'zt') {
      return (
        <a onTouchTap={this.handleViewShopsInTheCity} className="shop-all__view-shop-incity o-bg-grey">
          <FormattedMessage {...shopText.shopshowAllShop} />
        </a>
      );
    }

    return null;
  },
  render() {
    const { showLoad } = this.state;
    const { tabActive, yunChengSchoolFlag } = this.props;
    let allShopList = '';
    let nearShopList = '';
    let renderShopListWsElem = '';
    let renderShopListZtElem = '';

    if (yunChengSchoolFlag) {
      allShopList = this.getYCSAllShopList();
      nearShopList = this.getYCSNearShopList();
      renderShopListWsElem = this.renderYcsShopListWs();
      renderShopListZtElem = this.renderYcsShopListZt();
    } else {
      allShopList = this.getAllShopList();
      nearShopList = this.getNearShopList();
      renderShopListWsElem = this.renderShopListWs();
      renderShopListZtElem = this.renderShopListZt();
    }
    const showContentStatus = this.getShowContentStatus();
    return (
      <div className="shop-all-outer">
        <div className={classnames('searchws', { hide: tabActive === 'zt' })}>{renderShopListWsElem}</div>
        <div className={classnames('searchzt', { hide: tabActive === 'ws' })}>{renderShopListZtElem}</div>
        <div className="shop-all">
          <div className="record">
            <div>
              {showContentStatus.showNear && nearShopList}
              {showContentStatus.showAll && allShopList}
            </div>
          </div>
          {showLoad && allShopList && (
            <div className="loading">
              <FormattedMessage {...shopText.shopdropToLoadShop} />
            </div>
          )}
          <div className="copyrightbt">
            <FormattedMessage {...shopText.shopkrySupport} />
          </div>
        </div>
      </div>
    );
  },
});

module.exports = shopAll;



// WEBPACK FOOTER //
// ./src/component/shop-list/shop-all.jsx